import http from './http'

export default class MemberApi {
	static oauth2Login (params) {
		return http.httpGet('/lavrock/oauth2/system', params)
	}
	static authorizeNswYun (params) {
		return http.httpGet('/Authorize/nswyun', params)
	}
	static authorizeNewNSY (params) {
		// return http.httpGet('/Authorize/nswyun', params)
		return http.httpPost('/Authorize/loginOther', params)
	}
}
